import { useJwtAuthenticatedApiClient } from '@guiker/react-framework'
import { JwtAuthenticatedApiClient } from '@guiker/rental-listing-shared'

export const useJwtAuthenticatedListingApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)
